export default __webpack_public_path__ + "static/media/icon.cb991013.svg";